// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bMIDRKDeo4DolldDWgai {
  width: 100%;
  max-width: 56rem;
  margin: 0 auto;
  box-sizing: border-box;
}

.BTpJFoBZnsDDg3PSyVcg {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3);
}

.TxFgaKH6sEE7ErShZOFM {
  margin-bottom: var(--sl-space-4);
}

.hlfam5oa3BGTgGjRi0EO {
  margin: 0 0 var(--sl-space-1);
  font: var(--sl-text-display-2-font);
  letter-spacing: var(--sl-letter-spacing-3);
  color: var(--sl-fg-base);
}

.MKi2DzInABLQRe_pU22y {
  margin: 0;
  max-width: 32rem;
  font: var(--sl-text-body-font);
  color: var(--sl-fg-base-soft);
}

.JLMG87tNtEc0BowDuHLz {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2);
  margin-bottom: var(--sl-space-3);
}

/* Aproxima o FilterSearch legado ao search do protótipo */
.JLMG87tNtEc0BowDuHLz .filtersWrapper {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  gap: 0;
}

.JLMG87tNtEc0BowDuHLz .filterWrapper {
  width: 100%;
  max-width: none;
  grid-column: auto !important;
}

.JLMG87tNtEc0BowDuHLz .selectSearchableWrapper,
.JLMG87tNtEc0BowDuHLz .filterWrapper > * {
  width: 100%;
}

.JLMG87tNtEc0BowDuHLz input[type='search'],
.JLMG87tNtEc0BowDuHLz input[type='text'] {
  min-height: 2.75rem;
  border-radius: var(--sl-radius-2);
}

.VUr7_vRGKdeMNd2oloHM {
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
}

.VUr7_vRGKdeMNd2oloHM strong {
  color: var(--sl-fg-base);
  font-weight: 600;
}

.V9MNN5LYmv1nSqQNm3cX {
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-3);
  overflow: hidden;
}

.V9MNN5LYmv1nSqQNm3cX [data-sl-table] {
  width: 100%;
}

.V9MNN5LYmv1nSqQNm3cX [data-sl-table-header-cell] {
  font: var(--sl-text-caption-1-font);
  font-weight: 600;
  color: var(--sl-fg-base-soft);
  letter-spacing: normal;
  min-height: 2.5rem;
  padding: var(--sl-space-3);
}

.V9MNN5LYmv1nSqQNm3cX [data-sl-table-cell] {
  min-height: 2.75rem;
  padding: var(--sl-space-3);
  font: var(--sl-text-body-font);
  color: var(--sl-fg-base);
}

.JcZ1xVE5vjj0e1r_jcbN {
  display: contents;
}

.srTZrGb_TCb2KGcv3jcQ {
  cursor: default;
}

.J8baK8Dg4rgQlSMPxfZS {
  cursor: pointer;
}

.J8baK8Dg4rgQlSMPxfZS:hover [data-sl-table-cell],
.C7roegqN_Vigjyr0njCG [data-sl-table-cell] {
  background: var(--sl-bg-base-soft);
}

.J8baK8Dg4rgQlSMPxfZS:active [data-sl-table-cell] {
  background: var(--sl-bg-muted);
}

.k5tyCk_9U_0SG_CicrlI {
  display: flex;
  align-items: center;
  gap: var(--sl-space-2);
  min-width: 0;
  width: 100%;
  text-decoration: none;
  color: inherit;
}

.IEHb9LlAHPSN16UfPvMx {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--sl-text-body-font);
  color: var(--sl-fg-accent);
}

.k5tyCk_9U_0SG_CicrlI:hover .IEHb9LlAHPSN16UfPvMx {
  color: var(--sl-fg-accent-hover);
  text-decoration: underline;
}

.RrVxHe5DLyoMrjjRzjAJ {
  font: var(--sl-text-emphasis-font);
  font-variant-numeric: tabular-nums;
  color: var(--sl-fg-base);
}

.GiDNL8yLiKBuWCzlWslg {
  color: var(--sl-fg-base-soft);
}

.Zvyd3RMLqLOLFsG8YDjZ {
  white-space: nowrap;
}

.ZqoVhLGVQuX0BC4l4dwG,
.FnhfeNwmZo8TkRQ9DTZ1 {
  padding-block: var(--sl-space-3) !important;
  padding-inline-start: var(--sl-space-3) !important;
  padding-inline-end: var(--sl-space-3) !important;
}

.V9MNN5LYmv1nSqQNm3cX[data-has-origins-column='true'] .ZqoVhLGVQuX0BC4l4dwG,
.V9MNN5LYmv1nSqQNm3cX[data-has-origins-column='true'] .FnhfeNwmZo8TkRQ9DTZ1 {
  padding-inline-start: var(--sl-space-2) !important;
}

.buTwjA8W6RlEM28JNEgl {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--sl-space-2);
  width: max-content;
}

.lYjhYpfdfBHW_18t4Ayg,
.CcaD8NT2Y27tuPBeHp7B {
  justify-content: flex-start !important;
  text-align: start;
}

.V9MNN5LYmv1nSqQNm3cX[data-has-origins-column='true'] .lYjhYpfdfBHW_18t4Ayg,
.V9MNN5LYmv1nSqQNm3cX[data-has-origins-column='true'] .CcaD8NT2Y27tuPBeHp7B {
  justify-content: flex-end !important;
  text-align: end;
}

.wEoSPmNhW8fEfgOsK69w,
.hemsXYKJdf93IyHPdXUA {
  justify-content: center !important;
  padding-block: var(--sl-space-3) !important;
  padding-inline-start: var(--sl-space-3) !important;
  padding-inline-end: var(--sl-space-5) !important;
}

.hQTDMvg0oPtKZiieHev0 {
  justify-content: flex-start !important;
  padding-block: var(--sl-space-3) !important;
  padding-inline-start: var(--sl-space-3) !important;
  padding-inline-end: 0 !important;
}

.NQogf2WTJs916gpm21FR {
  justify-content: flex-start !important;
  padding-block: var(--sl-space-3) !important;
  padding-inline-start: var(--sl-space-3) !important;
  padding-inline-end: 0 !important;
}

.It3xNja8Yx4Tb4_OzfsM svg {
  transform: rotate(180deg);
}

.VZ_EF4CBCMiP0On6Cket {
  grid-column: 1 / -1;
  padding: var(--sl-space-5) var(--sl-space-5) var(--sl-space-6);
  background: var(--sl-bg-base);
  border-bottom: var(--sl-border-base);
}

.VZ_EF4CBCMiP0On6Cket [data-sl-table-header-cell] {
  font: var(--sl-text-caption-1-font);
  font-weight: 600;
  color: var(--sl-fg-base-soft);
  min-height: auto;
  padding-block: var(--sl-space-1);
}

.VZ_EF4CBCMiP0On6Cket [data-sl-table-cell] {
  min-height: auto;
  padding-block: var(--sl-space-2);
  border-bottom: var(--sl-border-base);
}

.Vgeuja7SaoBPUZO6pPG8 {
  margin-top: var(--sl-space-3);
}

@media (prefers-reduced-motion: reduce) {
  .It3xNja8Yx4Tb4_OzfsM svg {
    transition: none;
  }
}

@media (max-width: 48rem) {
  .Zvyd3RMLqLOLFsG8YDjZ {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/CheckingAccountTable/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,MAAM;AACR;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2CAA2C;EAC3C,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,2CAA2C;EAC3C,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".shell {\n  width: 100%;\n  max-width: 56rem;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-3);\n}\n\n.headerPage {\n  margin-bottom: var(--sl-space-4);\n}\n\n.headerTitle {\n  margin: 0 0 var(--sl-space-1);\n  font: var(--sl-text-display-2-font);\n  letter-spacing: var(--sl-letter-spacing-3);\n  color: var(--sl-fg-base);\n}\n\n.headerSub {\n  margin: 0;\n  max-width: 32rem;\n  font: var(--sl-text-body-font);\n  color: var(--sl-fg-base-soft);\n}\n\n.toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-2);\n  margin-bottom: var(--sl-space-3);\n}\n\n/* Aproxima o FilterSearch legado ao search do protótipo */\n.toolbar :global(.filtersWrapper) {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  gap: 0;\n}\n\n.toolbar :global(.filterWrapper) {\n  width: 100%;\n  max-width: none;\n  grid-column: auto !important;\n}\n\n.toolbar :global(.selectSearchableWrapper),\n.toolbar :global(.filterWrapper > *) {\n  width: 100%;\n}\n\n.toolbar :global(input[type='search']),\n.toolbar :global(input[type='text']) {\n  min-height: 2.75rem;\n  border-radius: var(--sl-radius-2);\n}\n\n.meta {\n  font: var(--sl-text-caption-1-font);\n  color: var(--sl-fg-base-soft);\n}\n\n.meta strong {\n  color: var(--sl-fg-base);\n  font-weight: 600;\n}\n\n.tableCard {\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-3);\n  overflow: hidden;\n}\n\n.tableCard :global([data-sl-table]) {\n  width: 100%;\n}\n\n.tableCard :global([data-sl-table-header-cell]) {\n  font: var(--sl-text-caption-1-font);\n  font-weight: 600;\n  color: var(--sl-fg-base-soft);\n  letter-spacing: normal;\n  min-height: 2.5rem;\n  padding: var(--sl-space-3);\n}\n\n.tableCard :global([data-sl-table-cell]) {\n  min-height: 2.75rem;\n  padding: var(--sl-space-3);\n  font: var(--sl-text-body-font);\n  color: var(--sl-fg-base);\n}\n\n.rowGroup {\n  display: contents;\n}\n\n.mainRow {\n  cursor: default;\n}\n\n.mainRowExpandable {\n  cursor: pointer;\n}\n\n.mainRowExpandable:hover :global([data-sl-table-cell]),\n.mainRowOpen :global([data-sl-table-cell]) {\n  background: var(--sl-bg-base-soft);\n}\n\n.mainRowExpandable:active :global([data-sl-table-cell]) {\n  background: var(--sl-bg-muted);\n}\n\n.accountCell {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  min-width: 0;\n  width: 100%;\n  text-decoration: none;\n  color: inherit;\n}\n\n.accountName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--sl-text-body-font);\n  color: var(--sl-fg-accent);\n}\n\n.accountCell:hover .accountName {\n  color: var(--sl-fg-accent-hover);\n  text-decoration: underline;\n}\n\n.balance {\n  font: var(--sl-text-emphasis-font);\n  font-variant-numeric: tabular-nums;\n  color: var(--sl-fg-base);\n}\n\n.balanceZero {\n  color: var(--sl-fg-base-soft);\n}\n\n.originsCell {\n  white-space: nowrap;\n}\n\n.accountHeader,\n.accountCellWrapper {\n  padding-block: var(--sl-space-3) !important;\n  padding-inline-start: var(--sl-space-3) !important;\n  padding-inline-end: var(--sl-space-3) !important;\n}\n\n.tableCard[data-has-origins-column='true'] .accountHeader,\n.tableCard[data-has-origins-column='true'] .accountCellWrapper {\n  padding-inline-start: var(--sl-space-2) !important;\n}\n\n.originTags {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: var(--sl-space-2);\n  width: max-content;\n}\n\n.balanceHeader,\n.balanceCell {\n  justify-content: flex-start !important;\n  text-align: start;\n}\n\n.tableCard[data-has-origins-column='true'] .balanceHeader,\n.tableCard[data-has-origins-column='true'] .balanceCell {\n  justify-content: flex-end !important;\n  text-align: end;\n}\n\n.actionHeader,\n.actionCell {\n  justify-content: center !important;\n  padding-block: var(--sl-space-3) !important;\n  padding-inline-start: var(--sl-space-3) !important;\n  padding-inline-end: var(--sl-space-5) !important;\n}\n\n.chevronHeader {\n  justify-content: flex-start !important;\n  padding-block: var(--sl-space-3) !important;\n  padding-inline-start: var(--sl-space-3) !important;\n  padding-inline-end: 0 !important;\n}\n\n.chevronCell {\n  justify-content: flex-start !important;\n  padding-block: var(--sl-space-3) !important;\n  padding-inline-start: var(--sl-space-3) !important;\n  padding-inline-end: 0 !important;\n}\n\n.chevronOpen :global(svg) {\n  transform: rotate(180deg);\n}\n\n.expandPanel {\n  grid-column: 1 / -1;\n  padding: var(--sl-space-5) var(--sl-space-5) var(--sl-space-6);\n  background: var(--sl-bg-base);\n  border-bottom: var(--sl-border-base);\n}\n\n.expandPanel :global([data-sl-table-header-cell]) {\n  font: var(--sl-text-caption-1-font);\n  font-weight: 600;\n  color: var(--sl-fg-base-soft);\n  min-height: auto;\n  padding-block: var(--sl-space-1);\n}\n\n.expandPanel :global([data-sl-table-cell]) {\n  min-height: auto;\n  padding-block: var(--sl-space-2);\n  border-bottom: var(--sl-border-base);\n}\n\n.footer {\n  margin-top: var(--sl-space-3);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .chevronOpen :global(svg) {\n    transition: none;\n  }\n}\n\n@media (max-width: 48rem) {\n  .originsCell {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `bMIDRKDeo4DolldDWgai`,
	"page": `BTpJFoBZnsDDg3PSyVcg`,
	"headerPage": `TxFgaKH6sEE7ErShZOFM`,
	"headerTitle": `hlfam5oa3BGTgGjRi0EO`,
	"headerSub": `MKi2DzInABLQRe_pU22y`,
	"toolbar": `JLMG87tNtEc0BowDuHLz`,
	"meta": `VUr7_vRGKdeMNd2oloHM`,
	"tableCard": `V9MNN5LYmv1nSqQNm3cX`,
	"rowGroup": `JcZ1xVE5vjj0e1r_jcbN`,
	"mainRow": `srTZrGb_TCb2KGcv3jcQ`,
	"mainRowExpandable": `J8baK8Dg4rgQlSMPxfZS`,
	"mainRowOpen": `C7roegqN_Vigjyr0njCG`,
	"accountCell": `k5tyCk_9U_0SG_CicrlI`,
	"accountName": `IEHb9LlAHPSN16UfPvMx`,
	"balance": `RrVxHe5DLyoMrjjRzjAJ`,
	"balanceZero": `GiDNL8yLiKBuWCzlWslg`,
	"originsCell": `Zvyd3RMLqLOLFsG8YDjZ`,
	"accountHeader": `ZqoVhLGVQuX0BC4l4dwG`,
	"accountCellWrapper": `FnhfeNwmZo8TkRQ9DTZ1`,
	"originTags": `buTwjA8W6RlEM28JNEgl`,
	"balanceHeader": `lYjhYpfdfBHW_18t4Ayg`,
	"balanceCell": `CcaD8NT2Y27tuPBeHp7B`,
	"actionHeader": `wEoSPmNhW8fEfgOsK69w`,
	"actionCell": `hemsXYKJdf93IyHPdXUA`,
	"chevronHeader": `hQTDMvg0oPtKZiieHev0`,
	"chevronCell": `NQogf2WTJs916gpm21FR`,
	"chevronOpen": `It3xNja8Yx4Tb4_OzfsM`,
	"expandPanel": `VZ_EF4CBCMiP0On6Cket`,
	"footer": `Vgeuja7SaoBPUZO6pPG8`
};
export default ___CSS_LOADER_EXPORT___;
